import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/vasudharini Homes - Black.png';
import { FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="sm:px-5 lg:px-10">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-1">
            <img src={logo} alt="Vasudharini" className="h-28 w-28 " />
            <p className="text-gray-700 mb-4">
              Vasudharini means bearer of earth. We are committed to delivering our promises
              through affordable luxury homes that meet your needs.
            </p>
            <p className="text-gray-700 text-sm">RERA No: <span className='font-medium'>PRM/KA/RERA/1251/308/PR/120625/007818</span></p>
          </div>

          {/* Quick Links */}
          <div className="col-span-1 mx-0 md:mx-auto ">
            <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-700 hover:text-yellow-500 transition-colors">Home</Link></li>
              {/* <li><Link to="/projects" className="text-gray-700 hover:text-yellow-500 transition-colors">Projects</Link></li> */}
              <li><Link to="/ongoing-projects" className="text-gray-700 hover:text-yellow-500 transition-colors">Vasudharini Nest</Link></li>
              <li><Link to="/about" className="text-gray-700 hover:text-yellow-500 transition-colors">About</Link></li>
              <li><Link to="/contact" className="text-gray-700 hover:text-yellow-500 transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Current Project */}
          <div className="col-span-1">
            <h3 className="text-xl font-semibold mb-4">Vasudharini Nest</h3>
            <ul className="space-y-2">
              <li className="text-gray-700">Spanish Architecture</li>
              <li className="text-gray-700">Located in Sarjapur, Bengaluru</li>
              {/* <li className="text-gray-700">RERA Approved</li> */}
              {/* <li className="text-gray-700">Launch Offers Available</li> */}
              <li>
                <Link
                  to="/upcoming-projects"
                  className="text-yellow-400 hover:text-yellow-300 transition-colors"
                >
                  Learn More →
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-span-1">
            <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-2">
              <li className="flex items-start space-x-2">
                <div className="flex-shrink-0"> {/* Add this wrapper to prevent icon shrinking */}
                  <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <span className="text-gray-700">#228/1, 1st Floor, 17th E Main, K.H.B. Colony, Koramangala, Bengaluru - 560 095. </span>
              </li>
              <li className="flex items-start space-x-2">
                <svg className="w-5 h-5 mt-1 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span className="text-gray-700">+91 9036026133</span>
              </li>
              <li className="flex items-start space-x-2">
                <div className="flex-shrink-0">
                  <svg className="w-5 h-5 mt-1 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <span className="text-gray-700 text-wrap">
                  <span className="font-medium">General Inquiries:</span> info@vasudharinihomes.com
                </span>
              </li>
              <li className="flex items-start space-x-2">
                <div className="flex-shrink-0">
                  <svg className="w-5 h-5 mt-1 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <span className="text-gray-700 text-wrap">
                  <span className="font-medium">Sales & Bookings:</span> sales@vasudharinihomes.com
                </span>
              </li>
            </ul>
          </div>
        </div>

        <hr className="border-gray-800 my-5" />

        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">© {new Date().getFullYear()} Vasudharini. All rights reserved. Designed by <a href="https://www.elzonex.com/" className="hover:underline text-gray-700">ElzoneX </a>Calicut.</p>
          <div className="flex space-x-4 mt-4 md:mt-0">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-yellow-400">
              <FaFacebook size={24} />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-yellow-400">
              <FaYoutube size={24} />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-yellow-400">
              <FaInstagram size={24} />
            </a>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
